import { useIntl } from 'react-intl';

import { FormattedMessage } from 'react-intl';
import { useStyles } from './birthday.styles';
import { BIRTHDAY_DATE_FORMAT } from '../../../../../../constants';

export const Birthday = ({ date }: { date: string }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <>
      <div data-testid="birthday">
        <h3 className={classes.title}>
          <FormattedMessage id="profile.dateOfBirthTextField.label" />
          <span className={classes.asterisk}>*</span>
        </h3>
        { /* @ts-ignore */ }
        {date && (<p className={classes.text}>{new Date(date).toLocaleDateString(intl.locale, BIRTHDAY_DATE_FORMAT)}</p>)}
      </div>
      <p className={classes.disclaimer}>{intl.formatMessage({ id: 'viewKidsProfile.disclaimer.date' })}</p>
    </>
  );
};
